export default __webpack_public_path__ + "static/media/kochul_logo.7f8016a1.png";